import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import { func, bool, string } from 'prop-types'
import { Box } from '@material-ui/core'
import { update } from '../../../modules/appointment'

function DialogCOmponent (props) {
  const handleChangeStatus = async val => {
    await update(props.id, { isPaid: val })
    props.onClose()
    props.callback()
  }

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <Box p={5}>
        <DialogTitle>Selecciona una opcion</DialogTitle>
        <List>
          <ListItem style={{ fontSize: '1.2em' }} autoFocus button onClick={event => handleChangeStatus(true)}>
            Pagado
          </ListItem>
          <ListItem style={{ fontSize: '1.2em' }} autoFocus button onClick={event => handleChangeStatus(false)}>
            No Pagado
          </ListItem>
        </List>
      </Box>
    </Dialog>
  )
}

DialogCOmponent.propTypes = {
  onClose: func,
  open: bool,
  id: string,
  callback: func
}

export default DialogCOmponent
